import { z } from "zod";

// Schemas

export const MunicipalitySchema = z.object({
  id: z.number(),
  stateId: z.number(),
  state: z.string(),
  countyId: z.number(),
  county: z.string(),
  typeId: z.number(),
  type: z.string(),
  name: z.string(),
  population: z.number(),
});

export const MunicipalityWRateSchema = MunicipalitySchema.extend({
  rate: z.number(),
  population_based_rate: z.number(),
});
